import { Button } from "react-bootstrap";

const IconButton = ({ onClick, children }) => {
  return (
    <Button
      onClick={onClick}
      className="p-0"
      variant="transparent"
      type="button"
    >
      {children}
    </Button>
  )
}

export default IconButton;